<template>
  <v-overlay v-model="isVisible" class="delete-overlay" z-index="9999">
    <div class="delete-modal" @click.stop>
      <div class="modal-content">
        <div class="modal-icon mb-4">
          <div class="icon-container">
            <v-icon color="error" size="40">
              mdi-alert-circle
            </v-icon>
          </div>
        </div>

        <div class="modal-text text-center mb-6">
          <h3 class="ds-panel-title mb-2">
            Are you sure you want to delete?
          </h3>
          <p class="text-body-2 text--secondary">
            {{ detailText }}
          </p>
        </div>

        <div class="modal-buttons d-flex gap-3">
          <v-btn
            color="surface-1"
            variant="flat"
            size="large"
            elevation="0"
            :disabled="confirmLoading"
            @click="onCancel">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            size="large"
            elevation="0"
            :loading="confirmLoading"
            :disabled="confirmLoading"
            @click="onConfirm">
            Yes, Delete
          </v-btn>
        </div>
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'DeleteConfirmationModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** When true, confirm button shows loading and buttons are disabled */
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    /** Secondary line under the title (default: generic warning) */
    detail: {
      type: String,
      default: '',
    },
  },
  computed: {
    detailText() {
      return (this.detail && this.detail.trim())
        ? this.detail
        : 'This action cannot be undone.';
    },
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('cancel');
        }
      },
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';

// Delete Modal Styles
.delete-overlay {
  z-index: 9999;
}

.delete-modal {
  background: $light-surface-2;
  border-radius: 12px;
  max-width: 480px;
  width: 90vw;
  box-shadow: 0px 8px 16px 8px rgba(38, 46, 53, 0.08);
}

.modal-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-icon {
  .icon-container {
    width: 64px;
    height: 64px;
    background: $light-surface-1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      inset: 2.5px;
      background: #FFD6D6;
      border-radius: 50%;
      z-index: 0;
    }

    .v-icon {
      z-index: 1;
      position: relative;
    }
  }
}

.modal-text {
  h3 {
    color: $light-foreground-1;
    margin-bottom: 8px;
  }

  p {
    color: $light-foreground-2;
  }
}

.modal-buttons {
  width: 100%;
  gap: 12px;
  button {
    flex: 1;
    font-weight: 600;
    &:first-child {
      color: $light-foreground-1;
      background-color: $light-surface-1;
    }
  }
}
</style>
